<template>
  <SfScrollable
    class="relative size-full [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    :drag="{ containerWidth: true }"
  >
    <template #previousButton="props">
      <UiIconButton
        v-if="showArrows"
        :id="`slider-${id}-previous`"
        variant="secondary"
        type="filled"
        border
        rounded
        :icon="IconChevron"
        class="absolute z-10 rotate-90"
        :class="[
          { '-left-5 -translate-y-10 md:-translate-y-8': placement === 'aside' },
          { 'bottom-0 right-12 md:right-20': placement === 'bottom' },
        ]"
        :disabled="props.disabled"
        @click="props.onClick"
      />
    </template>
    <slot />
    <template #nextButton="props">
      <UiIconButton
        v-if="showArrows"
        :id="`slider-${id}-next`"
        variant="secondary"
        type="filled"
        border
        rounded
        :icon="IconChevron"
        class="absolute z-10 -rotate-90"
        :class="[
          { '-right-5 -translate-y-10 md:-translate-y-8': placement === 'aside' },
          { 'bottom-0 right-0 md:right-8': placement === 'bottom' },
        ]"
        :disabled="props.disabled"
        @click="props.onClick"
      />
    </template>
  </SfScrollable>
</template>

<script setup lang="ts">
import { IconChevron } from '#components';

import type { SliderProps } from '~/components/ui/Slider/types';

withDefaults(defineProps<SliderProps>(), { placement: 'aside' });
</script>
